import {SectionBase} from "./SectionBase.js";
import * as THREE from "three";

export default class EvaluationSection extends SectionBase{
    constructor(options) {
        super(options);
    }

    setGeometries() {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneGeometry(16, 8)
    }

    setMeshes() {
        this.meshes = {}
        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneGeometry(2, 0.5), new THREE.MeshBasicMaterial({
            transparent: true,
            depthWrite: false,
            color: 0xffffff,
            alphaMap: this.resources.items.areaOpenTexture
        }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }
    setItemConfigs() {
        this.list = [
            {
                name: 'keppler',
                x: 270,
                y: -30,
                cameraAngle: 'projects',
                interactionTypes: ['showTexture'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/keppler/slideA.jpg',
                        './models/projects/keppler/slideB.jpg',
                        './models/projects/keppler/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsGleecChatFloorTexture,
                floorTextureOffsetX:5,
                floorTextureOffsetY:7,

            link:
                {
                    href: 'https://brunosimon.github.io/keppler/',
                    x: -4.8,
                    y: -3.4,
                    halfExtents:
                        {
                            x: 3.2,
                            y: 1.5
                        }
                },
            distinctions: [
                {type: 'Evaluation', x: 9, y: -6}
            ]
        },
            {
                name: 'keppler',
                x: 285,
                y: -22,
                interactionTypes: ['checklist'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/keppler/slideA.jpg',
                        './models/projects/keppler/slideB.jpg',
                        './models/projects/keppler/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsKepplerFloorTexture,
                link:
                    {
                        href: 'https://brunosimon.github.io/keppler/',
                        x: -4.8,
                        y: -3.4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions: []
            },
            {
                name: 'keppler',
                x: 285,
                y: -38,
                interactionTypes: ['kennzahlen'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/keppler/slideA.jpg',
                        './models/projects/keppler/slideB.jpg',
                        './models/projects/keppler/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsKepplerFloorTexture,
                link:
                    {
                        href: 'https://brunosimon.github.io/keppler/',
                        x: -4.8,
                        y: -3.4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions: []
            },
            {
                name: 'keppler',
                x: 300,
                y: -30,
                cameraAngle: 'projects',
                interactionTypes: ['showVideo1'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/keppler/slideA.jpg',
                        './models/projects/keppler/slideB.jpg',
                        './models/projects/keppler/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsKepplerFloorTexture,
                link:
                    {
                        href: 'https://brunosimon.github.io/keppler/',
                        x: -4.8,
                        y: -3.4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions: []
            }
        ]
    }
    setRoads() {
        this.tiles.add({
            start: new THREE.Vector2(250,-32),
            delta: new THREE.Vector2(44,0)
        })
    }
    setStatic() {
    }
    setWalls() {
        super.setWalls()
        this.walls.add({
            object:
                {
                    ...this.dikes.brickOptions,
                    rotation: new THREE.Euler(0, 0, Math.PI * 0.5)
                },
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 298, this.y - 20, 0),
                    offsetWidth: new THREE.Vector3(1.05, 0, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: false,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 299.9, this.y - 21, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object:
                {
                    ...this.dikes.brickOptions,
                    rotation: new THREE.Euler(0, 0, Math.PI * 0.5)
                },
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 256, this.y - 20, 0),
                    offsetWidth: new THREE.Vector3(1.05, 0, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: false,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 255, this.y - 22, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })
        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x +255, this.y - 27.5, 0),
                    offsetWidth: new THREE.Vector3(0, - 1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })
    }
}